// extracted by mini-css-extract-plugin
module.exports = {"switch":"DatabaseToggle_switch__1ixw3","slider":"DatabaseToggle_slider__19Ip9","sliderRound":"DatabaseToggle_sliderRound__ns0Md","round":"DatabaseToggle_round__3zwOY"};